import React from 'react';

const HeroCard = ({ icon, title, description }) => {
  return (
    <div className="md:w-1/2 flex justify-center items-center">
      <div className="relative w-full max-w-lg">
        <div className="absolute top-0 -left-4 w-72 h-72 bg-accent rounded-full mix-blend-multiply filter blur-xl opacity-50 animate-blob"></div>
        <div className="absolute top-0 -right-4 w-72 h-72 bg-secondary rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
        <div className="absolute -bottom-8 left-20 w-72 h-72 bg-primary rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000"></div>
        <div className="relative">
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100 min-h-[220px] flex flex-col justify-center">
            <div className="flex justify-center mb-6">
              {icon}
            </div>
            <h3 className="text-xl font-semibold text-center mb-4">{title}</h3>
            <p className="text-gray-600 text-center min-h-[60px]">
              {description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroCard;